import {
  Action,
  Dispatch,
  ThunkAction,
  createAsyncThunk,
} from "@reduxjs/toolkit";
import {
  setIsLoading,
  setTotalCount,
  addDiscountSuccess,
  addDiscountError,
  getDiscountsSuccess,
  getDiscountsError,
  updateDiscountSuccess,
  updateDiscountError,
  getJewelleryDiscountModelSuccess,
  getJewelleryDiscountModelError,
  setPagination,
} from "./reducer";
import {
  getJewelleries as getJewelleriesApi,
  addJewelleryDiscount as addJewelleryDiscountApi,
  getJewelleryDiscounts as getJewelleryDiscountApi,
  updateJewelleryDiscount as updateJewelleryDiscountApi,
} from "helpers/backend_helper";
import { Id, toast } from "react-toastify";
import { RootState } from "slices";
import axios from "axios";

// export type updateDiscountBodyType = {
//     id: string;
//     fields: {
//         type: String;
//         value: number;
//         products: {
//             id: string;
//             isNew: boolean;
//             isDeleted: boolean;
//         }
//     }
// }

// Jewellery Discount

export const addJewelleryDiscount =
  (body: any) => async (dispatch: Dispatch) => {
    try {
      dispatch(setIsLoading(true));
      const response: any = await addJewelleryDiscountApi(body);
      toast.success("Discount added Successfully!", {
        autoClose: 2000,
      });
      // dispatch(setIsLoading(false));
      dispatch(addDiscountSuccess(response.result));
      return response;
    } catch (error: any) {
      toast.error("Discount added Failed!", { autoClose: 2000 });
      // dispatch(setIsLoading(false));
      dispatch(addDiscountError(error));
    } finally {
      dispatch(setIsLoading(false)); // End loading
    }
  };

export const getJewelleryDiscount =
  (body: any): ThunkAction<void, RootState, unknown, Action<string>> =>
  async (dispatch: Dispatch) => {
    try {
      dispatch(setIsLoading(true));
      const response: any = await getJewelleryDiscountApi(body);
      dispatch(setIsLoading(false));
      dispatch(setPagination(response.result.pagination));
      dispatch(getDiscountsSuccess(response.result.discounts));
    } catch (error: any) {
      dispatch(setIsLoading(false));
      dispatch(getDiscountsError(error));
    }
  };

export const getJewelleryDiscountModel =
  (body: any): ThunkAction<void, RootState, unknown, Action<string>> =>
  async (dispatch: Dispatch) => {
    try {
      dispatch(setIsLoading(true));
      const response: any = await getJewelleriesApi(body);
      dispatch(setIsLoading(false));
      dispatch(getJewelleryDiscountModelSuccess(response.result.data));
      dispatch(setTotalCount(response.result.totalCount));
    } catch (error: any) {
      dispatch(setIsLoading(false));
      dispatch(getJewelleryDiscountModelError(error));
    }
  };

export const updateJewelleryDiscount =
  (body: any) => async (dispatch: Dispatch) => {
    try {
      dispatch(setIsLoading(true));
      const response: any = await updateJewelleryDiscountApi(body);
      toast.success("Discount Updated Successfully!", {
        autoClose: 2000,
      });
      dispatch(updateDiscountSuccess(response.result));
      // return Promise.resolve(response);
      return response;
      // toast.success("Discount updated Successfully!", { autoClose: 2000 });
      // dispatch(setIsLoading(false));
      // dispatch(updateDiscountSuccess(response.result));
    } catch (error: any) {
      toast.error("Discount updated Failed!", { autoClose: 2000 });
      // dispatch(setIsLoading(false));
      dispatch(updateDiscountError(error));
      // return Promise.reject(error);
    }  finally {
      dispatch(setIsLoading(false)); // End loading
    }
  };
